import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { deleteTopOffer } from '@services/shoppingCartService';
import { cartQueryKey } from '@hooks/useCart/useCart';
import type { ShoppingCartDTO } from '@t/api.types';

interface UseDeleteTopOfferOptions {
  onError?: (error: Error) => void;
}

export const useDeleteTopOffer = (
  sessionId: string,
  { onError }: UseDeleteTopOfferOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, string> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, string>({
    mutationFn: (itemId) => deleteTopOffer(sessionId, itemId),
    onSuccess: (cart) => queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart),
    onError,
  });
};
